export const removeChecksum = (labelNumber) => {
    if (labelNumber.length !== 8) {
        return labelNumber;
    }

    // remove barcode checksum
    let checksum =
        (parseInt(labelNumber.substr(0, 1)) +
            parseInt(labelNumber.substr(2, 1)) +
            parseInt(labelNumber.substr(4, 1)) +
            parseInt(labelNumber.substr(6, 1))) *
        3 +
        parseInt(labelNumber.substr(1, 1)) +
        parseInt(labelNumber.substr(3, 1)) +
        parseInt(labelNumber.substr(5, 1));

    if (checksum % 10 === 0) {
        checksum = 0;
    } else {
        checksum = (Math.floor(checksum / 10) + 1) * 10 - checksum;
    }

    if (parseInt(labelNumber.substr(7, 1)) !== checksum) {
        return null;
    }

    return labelNumber.substr(0, 7);
};
